import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { Clock } from "lucide-react";

interface Props {
  open: boolean;
  secondsLeft: number;
  onExtend: () => void;
  onLogout: () => void;
}

export function SessionTimeoutDialog({ open, secondsLeft, onExtend, onLogout }: Props) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Clock className="w-5 h-5 text-amber-500" />
            Session About to Expire
          </AlertDialogTitle>
          <AlertDialogDescription>
            For security, your session will automatically end in{" "}
            <span className="font-semibold text-foreground">
              {secondsLeft >= 60
                ? `${Math.floor(secondsLeft / 60)}:${String(secondsLeft % 60).padStart(2, "0")} minutes`
                : `${secondsLeft} second${secondsLeft !== 1 ? "s" : ""}`}
            </span>{" "}
            due to inactivity. Any unsaved progress will be lost.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onLogout} className="text-destructive hover:text-destructive">
            Log Out Now
          </AlertDialogCancel>
          <AlertDialogAction onClick={onExtend}>
            Stay Logged In
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
